import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import $ from 'jquery';
import DataTable from "react-data-table-component";
import { Modal } from 'bootstrap';


function SaleReturn() {
    const [formData, setFormData] = useState({
        l1: [],
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        start_date: '',
        end_date: '',
        isAlert: false,
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [ldata, setLdata] = useState(null);
    const [selectedReturn, setSelectedReturn] = useState(null);
    const [returnItems, setReturnItems] = useState([]);
    const [image, setImage] = useState('');
    const [dataTable, setDataTable] = useState(null);

    const [finalItems, setFinalItems] = useState([]);
    const [finalSummary, setFinalSummary] = useState({});
    const [originalBill, setOriginalBill] = useState(null);

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=pharmacy`
            );
            if (res.data.status) {
                setImage(res.data.header_logo);
            }
        } catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    const imageUrlToBase64 = async (url) => {
        if (!url) return null;
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            if (!blob.type.startsWith('image/')) return null;
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image:", error);
            return null;
        }
    };

    const formatAge = (year, month, day) => {
        const parts = [];
        if (year) parts.push(`${year}Y`);
        if (month) parts.push(`${month}M`);
        if (day) parts.push(`${day}D`);
        return parts.length > 0 ? parts.join(" ") : "-";
    };

    const formatBillNo = (billId) => {
        return billId ? String(billId).padStart(3, "0") : "000";
    };

    const formatBillDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const attachUserInfo = (fd) => {
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('user_id',   u.user_id   || '');
            fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
            fd.append('user_role', u.role_id   || u.role_name || '');
          }
        } catch (e) {
          console.warn("attachUserInfo failed:", e);
        }
        return fd;
    };
    const numberToWords = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '';
        num = Math.round(Number(num));
        if (num === 0) return "Zero Rupees Only";
        const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ',
            'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ',
            'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
        const b = ['', '', 'Twenty ', 'Thirty ', 'Forty ', 'Fifty ',
            'Sixty ', 'Seventy ', 'Eighty ', 'Ninety '];
        if (num.toString().length > 9) return 'Overflow';
        const n = ('000000000' + num).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return '';
        let str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0) ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]]) : '';
        return str.trim().replace(/\s+/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) + ' Rupees Only';
    };

    // ══════════════════════════════════════════════════════════════════
    // GENERATE FINAL PHARMACY BILL PDF
    // ══════════════════════════════════════════════════════════════════
    const generateFinalPharmacyBillPdf = async (returnData, origBill, fItems, fSummary) => {
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;

        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;

        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
        }

        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });

        y += 15;
        doc.setFontSize(10);
        doc.setTextColor(220, 53, 69);
        doc.text("(After Return Adjustment)", pageWidth / 2, y, { align: "center" });
        doc.setTextColor(0, 0, 0);

        y += 10;
        doc.rect(margin, y, pageWidth - 2 * margin, 95);

        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Bill To:", leftX, lineY);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);

        const patientName = origBill?.med_bill_patient_number || returnData.med_bill_return_patient_name || 'Walk-in Customer';
        const patientPhone = origBill?.med_bill_phone_number || returnData.med_bill_return_phone || '';
        const patientDoctor = origBill?.med_bill_doctor || returnData.med_bill_return_doctor || '-';
        const uhid = origBill?.med_bill_ipd_number || returnData.med_bill_return_original_bill_number || '';

        const ageText = formatAge(
            origBill?.med_bill_age_year || returnData.med_bill_return_age_year,
            origBill?.med_bill_age_month || returnData.med_bill_return_age_month,
            origBill?.med_bill_age_day || returnData.med_bill_return_age_day
        );

        doc.text(`Patient Name : ${patientName}`, leftX, (lineY += 15));
        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${patientPhone}`, leftX, (lineY += 15));
        doc.text(`Doctor : ${patientDoctor}`, leftX, (lineY += 15));

        lineY = y + 15;
        doc.text(`UHID : ${uhid}`, rightX, lineY);
        doc.text(`Bill No : ${formatBillNo(origBill?.med_bill_id || returnData.med_bill_return_original_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Bill Date : ${formatBillDate(origBill?.med_bill_date || '')}`, rightX, (lineY += 15));
        doc.text(`Return No : ${formatBillNo(returnData.med_bill_return_bill_number)}`, rightX, (lineY += 15));
        doc.text(`Return Date : ${formatBillDate(returnData.med_bill_return_date)}`, rightX, (lineY += 15));

        y += 115;

        // ITEMS TABLE
        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Batch", "Expiry", "MRP", "Disc",
            "Orig\nQty", "Rtn\nQty", "Final\nQty", "Amount"
        ]];

        const tableBody = (fItems || []).map((item, index) => {
            let displayAmount;
            const returnQty = item.return_qty || 0;
            const finalQty = item.final_qty || 0;
            const finalAmt = item.final_amount || 0;
            const returnAmt = item.return_amount || 0;

            if (returnQty > 0 && finalQty === 0) {
                // Fully returned — show negative return amount
                displayAmount = `-${returnAmt.toFixed(2)}`;
            } else if (returnQty > 0 && finalQty > 0) {
                // Partially returned — show final amount with return deduction
                displayAmount = `${finalAmt.toFixed(2)}\n(-${returnAmt.toFixed(2)})`;
            } else {
                // No return — show final amount
                displayAmount = finalAmt.toFixed(2);
            }

            return [
                index + 1,
                item.medicine || '',
                item.pack_type || '',
                item.batch || '',
                item.exp || '',
                (item.mrp || 0).toFixed(2),
                (item.discount || 0).toFixed(2),
                item.original_qty || 0,
                item.return_qty > 0 ? `-${item.return_qty}` : '0',
                item.final_qty || 0,
                displayAmount,
            ];
        });

        const pageHeight = doc.internal.pageSize.getHeight();

        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 3 },
            headStyles: {
                fillColor: [64, 81, 137],
                textColor: 255,
                fontStyle: "bold",
                halign: 'center',
                valign: 'middle'
            },
            columnStyles: {
                0: { halign: 'center', cellWidth: 25 },
                1: { cellWidth: 130 },
                2: { halign: 'center', cellWidth: 45 },
                3: { halign: 'center', cellWidth: 50 },
                4: { halign: 'center', cellWidth: 45 },
                5: { halign: 'right', cellWidth: 45 },
                6: { halign: 'right', cellWidth: 35 },
                7: { halign: 'center', cellWidth: 35 },
                8: { halign: 'center', cellWidth: 35 },
                9: { halign: 'center', cellWidth: 35, fontStyle: 'bold' },
                10: { halign: 'right', cellWidth: 55, fontStyle: 'bold' },
            },
            // ✅ FIX: Allow table to span multiple pages
            showHead: 'everyPage',
            margin: { top: 40, bottom: 40, left: margin, right: margin },
            didParseCell: function(data) {
                // Return qty column in red
                if (data.column.index === 8 && data.section === 'body') {
                    const val = data.cell.raw;
                    if (val && val.toString().startsWith('-')) {
                        data.cell.styles.textColor = [220, 53, 69];
                        data.cell.styles.fontStyle = 'bold';
                    }
                }
                // Final qty = 0 in gray
                if (data.column.index === 9 && data.section === 'body') {
                    if (data.cell.raw === 0 || data.cell.raw === '0') {
                        data.cell.styles.textColor = [150, 150, 150];
                    }
                }
                // Amount column: negative amounts in red for return-only rows
                if (data.column.index === 10 && data.section === 'body') {
                    const val = data.cell.raw;
                    if (val && val.toString().startsWith('-')) {
                        data.cell.styles.textColor = [220, 53, 69];
                        data.cell.styles.fontStyle = 'bold';
                    }
                }
                // Highlight return-only rows with light red background
                if (data.section === 'body') {
                    const rowIdx = data.row.index;
                    if (fItems[rowIdx] && fItems[rowIdx].is_return_only) {
                        data.cell.styles.fillColor = [255, 235, 238];
                    }
                }
            }
        });

        y = doc.lastAutoTable.finalY + 20;

        // ✅ FIX: Check if summary needs a new page (need ~150pt for summary section)
        const summarySpaceNeeded = 160;
        if (y + summarySpaceNeeded > pageHeight - 30) {
            doc.addPage();
            y = 40;
        }

        // SUMMARY
        const summaryX = pageWidth - margin - 220;
        const valX = pageWidth - margin;

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Original Bill Amount", summaryX, y);
        doc.text(`Rs ${(fSummary.original_final_amt || 0).toFixed(2)}`, valX, y, { align: "right" });

        y += 18;
        doc.setTextColor(220, 53, 69);
        doc.text("Total Return Amount", summaryX, y);
        doc.text(`- Rs ${(fSummary.total_all_return_amt || 0).toFixed(2)}`, valX, y, { align: "right" });
        doc.setTextColor(0, 0, 0);

        y += 5;
        doc.setLineWidth(0.5);
        doc.line(summaryX, y, valX, y);

        y += 18;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text("Final Amount", summaryX, y);
        doc.text(`Rs ${(fSummary.final_grand_total || 0).toFixed(2)}`, valX, y, { align: "right" });

        y += 22;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        // const originalPaid = fSummary.original_paid || 0;
        // if (originalPaid > 0) {
        //     doc.text("Amount Paid", summaryX, y);
        //     doc.text(`Rs ${originalPaid.toFixed(2)}`, valX, y, { align: "right" });

        //     y += 15;
        //     const refundAmt = fSummary.refund_amount || 0;
        //     if (refundAmt > 0) {
        //         doc.setTextColor(220, 53, 69);
        //         doc.text("Refund", summaryX, y);
        //         doc.text(`Rs ${refundAmt.toFixed(2)}`, valX, y, { align: "right" });
        //         doc.setTextColor(0, 0, 0);
        //     }
        // }

        y += 30;
        // ✅ Check page break before amount in words
        if (y + 80 > pageHeight - 30) {
            doc.addPage();
            y = 40;
        }

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Amount in Words: ${numberToWords(fSummary.final_grand_total || 0)}`, margin, y);

        const reason = returnData.med_bill_return_reason || '';
        if (reason) {
            y += 18;
            doc.setFont("helvetica", "italic");
            doc.setFontSize(8);
            doc.text(`Return Reason: ${reason}`, margin, y);
        }

        y += 18;
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.text("Note: This bill reflects the final amounts after return adjustment. Refund as per store policy.", margin, y);

        y += 25;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

        window.open(doc.output("bloburl"), "_blank");
    };

    // ══════════════════════════════════════════════════════════════════
    // FETCH RETURN DETAILS WITH ORIGINAL BILL
    // ══════════════════════════════════════════════════════════════════
    const fetchReturnDetailsWithOriginal = async (returnId) => {
        try {
            const fd = new FormData();
            fd.append('return_id', returnId);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getReturnDetailsWithOriginalUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (!response.data.status) {
                throw new Error(response.data.message || "Failed to load return details");
            }

            const bill = response.data.return_bill;
            const items = response.data.return_items || [];
            const origBill = response.data.original_bill;
            const fItems = response.data.final_items || [];
            const fSummary = response.data.final_summary || {};

            setSelectedReturn(bill);
            setReturnItems(items);
            setOriginalBill(origBill);
            setFinalItems(fItems);
            setFinalSummary(fSummary);

            return { bill, items, origBill, fItems, fSummary };

        } catch (error) {
            console.error("Error fetching return details:", error);
            toast.error("Error loading return details");
            return null;
        }
    };

    const handleDeleteReturn = async (returnId, returnNo) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `Do you want to delete Return No: <strong>${formatBillNo(returnNo)}</strong>?<br><small class="text-danger">This action cannot be undone!</small>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            focusCancel: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const fd = new FormData();
                    fd.append('return_id', returnId);
                    attachUserInfo(fd); 
                    const response = await axios.post(
                        AppConst.BASE_URL + AppConst.deleteMedReturnUrl,
                        fd,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );
                    if (response.data.status) {
                        toast.success('Return deleted successfully');
                        await initData();
                        Swal.fire({ title: 'Deleted!', text: 'Return has been deleted.', icon: 'success', timer: 2000, showConfirmButton: false });
                    } else {
                        toast.error(response.data.message || 'Failed to delete return');
                    }
                } catch (error) {
                    console.error("Error deleting return:", error);
                    toast.error("Error deleting return");
                }
            }
        });
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        setIsAdmin(roleId === 1 || roleId === "1");

        if (storedData) {
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            if (formData.start_date) fd.append('start_date', formData.start_date);
            if (formData.end_date) fd.append('end_date', formData.end_date);

            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getReturnListUrl, fd,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                if (response.data.status) {
                    const records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({ ...prev, l1: records }));
                    }
                }
            } catch (error) {
                console.error("Error fetching returns:", error);
                toast.error("Error loading returns");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const clearDates = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({ ...prev, start_date: today, end_date: today }));
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            const today = new Date().toISOString().split('T')[0];
            setFormData(prev => ({ ...prev, start_date: today, end_date: today }));
            fetchConfigData();
        }
        return () => { if (dataTable) dataTable.destroy(); };
    }, []);

    useEffect(() => {
        if (formData.start_date && formData.end_date) initData();
    }, [formData.start_date, formData.end_date]);

    const columns = [
        { name: "Sl. No.", selector: (row, index) => index + 1, width: "80px" },
        {
            name: "Action",
            cell: row => (
                <div className="d-flex gap-1 flex-wrap">
                    <button className="btn btn-sm btn-info" onClick={async () => {
                        const res = await fetchReturnDetailsWithOriginal(row.med_bill_return_id);
                        if (res) { const modal = new Modal(document.getElementById('returnDetailsModal')); modal.show(); }
                    }} title="View Details"><i className="ri-eye-line"></i></button>
                    <button className="btn btn-sm btn-primary" onClick={async () => {
                        const res = await fetchReturnDetailsWithOriginal(row.med_bill_return_id);
                        if (res) { generateFinalPharmacyBillPdf(res.bill, res.origBill, res.fItems, res.fSummary); }
                    }} title="Print Final Pharmacy Bill"><i className="ri-printer-line"></i></button>
                    {isAdmin && (
                        <button className="btn btn-sm btn-danger" onClick={() => handleDeleteReturn(row.med_bill_return_id, row.med_bill_return_bill_number)} title="Delete Return">
                            <i className="ri-delete-bin-line"></i>
                        </button>
                    )}
                </div>
            ),
            ignoreRowClick: true, button: true, width: "180px"
        },
        { name: "Patient Name", selector: row => row.med_bill_return_patient_name || "-", sortable: true },
        { name: "Phone No", selector: row => row.med_bill_return_phone || "-", sortable: true },
        { name: "Doctor", selector: row => row.med_bill_return_doctor || "-", sortable: true },
        { name: "Reason", selector: row => row.med_bill_return_reason || "-", grow: 2 },
        { name: "Return No", selector: row => row.med_bill_return_bill_number, sortable: true },
        { name: "Return Date", selector: row => formatBillDate(row.med_bill_return_date), sortable: true }
    ];

    const customStyles = {
        headRow: { style: { backgroundColor: '#405189', color: '#fff', fontSize: '14px', fontWeight: 'bold', borderRadius: '5px 5px 0 0' } },
        headCells: { style: { color: '#fff', paddingLeft: '16px', paddingRight: '16px' } },
        rows: { style: { fontSize: '14px', '&:hover': { backgroundColor: '#f8f9fa', cursor: 'pointer' } } }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Sales Return</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <button type="button" onClick={(e) => { e.preventDefault(); sessionStorage.removeItem("opd_dt"); window.location.href = "/sales_Return"; }} className="btn btn-success add-btn">
                                            <i className="ri-add-line align-bottom me-1"></i> Add Return
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-xxl-3 col-sm-6">
                                        <label className="form-label">Start Date</label>
                                        <input type="date" className="form-control" name="start_date" value={formData.start_date} onChange={handleChange} />
                                    </div>
                                    <div className="col-xxl-3 col-sm-6">
                                        <label className="form-label">End Date</label>
                                        <input type="date" className="form-control" name="end_date" value={formData.end_date} onChange={handleChange} />
                                    </div>
                                    <div className="col-xxl-2 col-sm-6 d-flex align-items-end">
                                        <button type="button" className="btn btn-secondary" onClick={clearDates}>
                                            <i className="ri-refresh-line me-1"></i> Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="card-body pt-0">
                                <DataTable columns={columns} data={formData.l1} customStyles={customStyles} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 25, 50, 100]} highlightOnHover pointerOnHover responsive striped
                                    noDataComponent={<div className="text-center py-5"><i className="ri-file-list-line fs-1 text-muted"></i><p className="mt-3">No return found</p></div>}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════
                MODAL — Final Pharmacy Bill After Return
                ══════════════════════════════════════════════════════ */}
            <div className="modal fade" id="returnDetailsModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: '#405189', color: '#fff' }}>
                            <h5 className="modal-title">
                                <i className="ri-file-list-3-line me-2"></i>
                                Final Pharmacy Bill — After Return
                            </h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedReturn && (
                                <div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <h6><i className="ri-user-line me-1"></i>Patient Information</h6>
                                            <p className="mb-1"><strong>Name:</strong> {originalBill?.med_bill_patient_number || selectedReturn.med_bill_return_patient_name}</p>
                                            <p className="mb-1"><strong>Phone:</strong> {originalBill?.med_bill_phone_number || selectedReturn.med_bill_return_phone}</p>
                                            <p className="mb-1"><strong>Age:</strong> {formatAge(
                                                originalBill?.med_bill_age_year || selectedReturn.med_bill_return_age_year,
                                                originalBill?.med_bill_age_month || selectedReturn.med_bill_return_age_month,
                                                originalBill?.med_bill_age_day || selectedReturn.med_bill_return_age_day
                                            )}</p>
                                            <p className="mb-0"><strong>Doctor:</strong> {originalBill?.med_bill_doctor || selectedReturn.med_bill_return_doctor}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6><i className="ri-bill-line me-1"></i>Bill Information</h6>
                                            <p className="mb-1"><strong>Original Bill No:</strong> {formatBillNo(selectedReturn.med_bill_return_original_bill_id)}</p>
                                            <p className="mb-1"><strong>Bill Date:</strong> {formatBillDate(originalBill?.med_bill_date)}</p>
                                            <p className="mb-1"><strong>Return No:</strong> <span className="badge bg-danger">{formatBillNo(selectedReturn.med_bill_return_bill_number)}</span></p>
                                            <p className="mb-1"><strong>Return Date:</strong> {formatBillDate(selectedReturn.med_bill_return_date)}</p>
                                            <p className="mb-0"><strong>Return Reason:</strong> <span className="text-danger">{selectedReturn.med_bill_return_reason || '-'}</span></p>
                                        </div>
                                    </div>

                                    <hr />

                                    <h6 className="mb-2">
                                        <i className="ri-medicine-bottle-line me-1"></i>
                                        Medicine Details (Original → Return → Final)
                                    </h6>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover table-sm align-middle">
                                            <thead style={{ backgroundColor: '#405189', color: '#fff' }}>
                                                <tr>
                                                    <th style={{ width: '40px' }}>Sl#</th>
                                                    <th>Medicine</th>
                                                    <th className="text-center">Pack</th>
                                                    <th>Batch</th>
                                                    <th className="text-end">MRP</th>
                                                    <th className="text-end">Disc</th>
                                                    <th className="text-center" style={{ backgroundColor: '#0d6efd' }}>Orig Qty</th>
                                                    <th className="text-center" style={{ backgroundColor: '#dc3545' }}>Rtn Qty</th>
                                                    <th className="text-center" style={{ backgroundColor: '#198754' }}>Final Qty</th>
                                                    <th className="text-end" style={{ backgroundColor: '#198754' }}>Final Amt</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {finalItems.map((item, idx) => {
                                                    const isReturnOnly = item.is_return_only === true;
                                                    const hasReturn = (item.return_qty || 0) > 0;
                                                    
                                                    return (
                                                        <tr key={idx} className={isReturnOnly ? 'table-danger' : hasReturn ? 'table-warning' : ''}>
                                                            <td className="text-center">{idx + 1}</td>
                                                            <td>
                                                                <strong>{item.medicine}</strong>
                                                                {isReturnOnly && (
                                                                    <span className="badge bg-danger ms-2" style={{ fontSize: '10px' }}>Returned</span>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={`badge ${item.is_loose === 1 ? 'bg-warning text-dark' : 'bg-info'}`}>
                                                                    {item.pack_type}
                                                                </span>
                                                            </td>
                                                            <td>{item.batch}</td>
                                                            <td className="text-end">₹{(item.mrp || 0).toFixed(2)}</td>
                                                            <td className="text-end">₹{(item.discount || 0).toFixed(2)}</td>
                                                            <td className="text-center">
                                                                <span className="badge bg-primary fs-6">{item.original_qty || 0}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                {(item.return_qty || 0) > 0 ? (
                                                                    <span className="badge bg-danger fs-6">-{item.return_qty}</span>
                                                                ) : (
                                                                    <span className="text-muted">0</span>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={`badge fs-6 fw-bold ${(item.final_qty || 0) > 0 ? 'bg-success' : 'bg-secondary'}`}>
                                                                    {item.final_qty || 0}
                                                                </span>
                                                            </td>
                                                            <td className="text-end fw-bold">
                                                                {(() => {
                                                                    const rQty = item.return_qty || 0;
                                                                    const fQty = item.final_qty || 0;
                                                                    const fAmt = item.final_amount || 0;
                                                                    const rAmt = item.return_amount || 0;

                                                                    if (rQty > 0 && fQty === 0) {
                                                                        // Fully returned
                                                                        return <span className="text-danger">-₹{rAmt.toFixed(2)}</span>;
                                                                    } else if (rQty > 0 && fQty > 0) {
                                                                        // Partially returned
                                                                        return (
                                                                            <div>
                                                                                <div>₹{fAmt.toFixed(2)}</div>
                                                                                <small className="text-danger">(-₹{rAmt.toFixed(2)})</small>
                                                                            </div>
                                                                        );
                                                                    } else {
                                                                        return <>₹{fAmt.toFixed(2)}</>;
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                            <tfoot className="table-light">
                                                <tr className="fw-bold">
                                                    <td colSpan="6" className="text-end">Totals:</td>
                                                    <td className="text-center">
                                                        {finalItems.reduce((s, i) => s + (i.original_qty || 0), 0)}
                                                    </td>
                                                    <td className="text-center text-danger">
                                                        -{finalItems.reduce((s, i) => s + (i.return_qty || 0), 0)}
                                                    </td>
                                                    <td className="text-center text-success">
                                                        {finalItems.reduce((s, i) => s + (i.final_qty || 0), 0)}
                                                    </td>
                                                    <td className="text-end">
                                                        ₹{finalItems.reduce((s, i) => s + (i.final_amount || 0), 0).toFixed(2)}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    {/* Summary */}
                                    <div className="row mt-3">
                                        <div className="col-md-6 offset-md-6">
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-body">
                                                    <p className="d-flex justify-content-between mb-2">
                                                        <span>Original Bill Amount:</span>
                                                        <span>₹{(finalSummary.original_final_amt || 0).toFixed(2)}</span>
                                                    </p>
                                                    <p className="d-flex justify-content-between mb-2 text-danger">
                                                        <span><i className="ri-arrow-left-up-line me-1"></i>Total Return Amount:</span>
                                                        <span>- ₹{(finalSummary.total_all_return_amt || 0).toFixed(2)}</span>
                                                    </p>
                                                    <hr className="my-2" />
                                                    <h5 className="d-flex justify-content-between mb-2 text-success">
                                                        <span><i className="ri-check-double-line me-1"></i>Final Amount:</span>
                                                        <span>₹{(finalSummary.final_grand_total || 0).toFixed(2)}</span>
                                                    </h5>
                                                    {(finalSummary.original_paid || 0) > 0 && (
                                                        <>
                                                            <hr className="my-2" />
                                                            <p className="d-flex justify-content-between mb-1">
                                                                <span>Paid:</span>
                                                                <span>₹{(finalSummary.original_paid || 0).toFixed(2)}</span>
                                                            </p>
                                                            {(finalSummary.refund_amount || 0) > 0 && (
                                                                <p className="d-flex justify-content-between mb-0 text-danger fw-bold">
                                                                    <span>Refund Due:</span>
                                                                    <span>₹{(finalSummary.refund_amount || 0).toFixed(2)}</span>
                                                                </p>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => {
                                if (selectedReturn) generateFinalPharmacyBillPdf(selectedReturn, originalBill, finalItems, finalSummary);
                            }}>
                                <i className="ri-printer-line me-1"></i> Print Final Bill
                            </button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SaleReturn;